import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-password',
	templateUrl: './icon-password.component.svg',
})
export class IconPasswordComponent {}
